module.exports = __webpack_public_path__ + "img/secure-transaction.1f2cd58.svg";